export function removeFile(files, file) {
  const index = files.indexOf(file)

  if (index === -1) return files

  return files.splice(index, 1)
}
